import { AppRouteGroup } from 'utils/routing/AppRouteGroup';

export const orgDashboardRouteGroup = new AppRouteGroup({
  path: '/admin/:orgId',
  params: ['orgId'],
});

export const orgDashboardHomeRoute = orgDashboardRouteGroup.route({
  path: '',
});

export const orgDashboardPostAListingRoute = orgDashboardRouteGroup.route({
  path: 'post-a-listing',
});

// Org

export const orgDashboardPreviewOrgRoute = orgDashboardRouteGroup.route({
  path: 'preview',
});

// Checkout

export const orgDashboardCheckoutBillingAddressRoute =
  orgDashboardRouteGroup.route({
    path: 'checkout/billing-address',
    searchParams: ['pack', 'invoiceId'],
  });

// Invoice

export const orgDashboardInvoiceRoute = orgDashboardRouteGroup.route({
  path: 'invoices/:invoiceId',
  params: ['invoiceId'],
});

// Job

export const orgDashboardViewJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/:jobId',
  params: ['jobId'],
});

export const orgDashboardPreviewJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/:jobId/preview',
  params: ['jobId'],
});

export const orgDashboardCreateJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/create',
});

export const orgDashboardEditJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/:jobId/edit',
  params: ['jobId'],
});

export const orgDashboardRepostJobRoute = orgDashboardRouteGroup.route({
  path: 'jobs/:jobId/repost',
  params: ['jobId'],
});

export const orgDashboardListJobRecommendedCandidatesRoute =
  orgDashboardRouteGroup.route({
    path: 'jobs/:jobId/recommended-candidates',
    params: ['jobId'],
  });

export const orgDashboardViewJobRecommendedCandidatesRoute =
  orgDashboardRouteGroup.route({
    path: 'jobs/:jobId/recommended-candidates/:applicantId',
    params: ['jobId', 'applicantId'],
  });

// Internship

export const orgDashboardViewInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/:internshipId',
  params: ['internshipId'],
});

export const orgDashboardPreviewInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/:internshipId/preview',
  params: ['internshipId'],
});

export const orgDashboardEditInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/:internshipId/edit',
  params: ['internshipId'],
});

export const orgDashboardCreateInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/create',
});

export const orgDashboardRepostInternshipRoute = orgDashboardRouteGroup.route({
  path: 'internships/:internshipId/repost',
  params: ['internshipId'],
});

// Volop

export const orgDashboardViewVolopRoute = orgDashboardRouteGroup.route({
  path: 'volops/:volopId',
  params: ['volopId'],
});

export const orgDashboardPreviewVolopRoute = orgDashboardRouteGroup.route({
  path: 'volops/:volopId/preview',
  params: ['volopId'],
});

export const orgDashboardCreateVolopRoute = orgDashboardRouteGroup.route({
  path: 'volops/create',
});
